import { StyleSheet } from 'react-native';
import colors from '../../../../../theme/Colors';
import size from '../../../../../theme/Fonts';
import Utility from '../../../../../utils/Utility';

const CartStyles = StyleSheet.create({
  container: {
    flex: 1,
    width: Utility.getScreenWidth(),
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
    overflow: 'hidden',
  },
  scrollView: {
    backgroundColor: colors.background,
    paddingBottom: 70 + Utility.bottomInset,
  },
  header: {
    position: 'absolute',
    top: 40,
    left: 0,
    right: 10,
    zIndex: 1,
    height: 52,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    backgroundColor: 'white',
  },
  crossButtonContainer: {
    height: 16,
    width: 16,
    marginRight: 16,
  },
  orderStatusCross: {
    height: 16,
    width: 16,
    position: 'absolute',
    top: 50,
    right: 24,
    zIndex: 1,
  },
  crossImage: {
    height: 16,
    width: 16,
    marginTop: 4,
    tintColor: colors.foxyBlack,
  },
  addressContainer: {
    marginTop: 4,
    marginBottom: 12 + Utility.bottomInset,
    backgroundColor: colors.white,
  },
  addressContainerForCartPage: {
    marginTop: 12,
    marginBottom: 4,
    backgroundColor: '#E4F2FF',
    paddingBottom: 8,
  },
  addressContainerProduct: {
    backgroundColor: colors.white,
  },
  addressTextContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  addAddressContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'center',
    height: 40,
    marginRight: 20,
  },
  addressHeaderText: {
    fontFamily: 'Roboto-Medium',
    fontSize: 14,
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#173143',
    paddingLeft: 12,
    marginTop: 8,
  },
  cartHeaderText: {
    position: 'absolute',
    fontFamily: 'Roboto-Regular',
    fontSize: 18,

    fontStyle: 'normal',
    letterSpacing: 0,
    color: colors.foxyBlack,
    left: 16,
  },
  plus: {
    height: 10,
    width: 10,
    tintColor: colors.cta.lightBlue,
    marginLeft: Utility.padding,
  },
  addAddressText: {
    fontFamily: 'Roboto-Medium',
    fontSize: 14,
    fontStyle: 'normal',
    letterSpacing: 0,
    color: colors.cta.lightBlue,
    marginLeft: 4,
  },
  rightArrow: {
    position: 'absolute',
    right: 0,
    marginRight: Utility.largePadding,
    tintColor: colors.foxyBlack,
  },
  rightArrowAddress: {
    position: 'absolute',
    right: 0,
    marginRight: Utility.largePadding,
    tintColor: colors.foxyBlack,
    top: 12,
  },
  checkoutInfoDockContainer: {
    position: 'absolute',
    bottom: 0,
    width: Utility.getScreenWidth(),
    backgroundColor: 'white',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    zIndex: 1,
  },
  activityIndicatorInCheckout: {
    position: 'absolute',
    alignSelf: 'center',
    left: 48,
  },
  paymentDock: {
    height: 56,
    backgroundColor: colors.white,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    borderTopWidth: 1,
    borderTopColor: colors.border,
  },
  priceInfoDockContainer: {
    height: 70,
    backgroundColor: colors.white,
    flexDirection: 'row',
    justifyContent: 'flex-start',
  },
  checkoutButton: {
    position: 'absolute',
    top: 12,
    right: Utility.largePadding,
    flexDirection: 'row',
    borderRadius: 4,
    justifyContent: 'center',
    alignItems: 'center',
  },
  checkoutButtonSecondary: {
    position: 'absolute',
    top: 12,
    right: Utility.largePadding,
    flexDirection: 'row',
    borderRadius: 4,
    justifyContent: 'center',
    alignItems: 'center',
    borderWidth: 1,
    borderColor: colors.foxyBlack,
  },
  checkoutText: {
    fontFamily: 'Roboto-Medium',
    fontSize: 18,
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'center',
    color: colors.white,
  },
  totalPriceContainer: {
    flexDirection: 'column',
    marginTop: 12,
    marginLeft: Utility.largePadding,
    height: 40,
    alignItems: 'flex-start',
  },
  totalText: {
    fontFamily: 'Roboto-Medium',
    fontSize: 12,
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'center',
    color: colors.disabled,
  },
  totalPrice: {
    fontFamily: 'Roboto-Medium',
    fontSize: 18,
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'center',
    color: colors.foxyBlack,
  },
  individualAddressContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  userAddressTextContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 12,
    marginRight: 12,
    marginTop: 12,
    marginBottom: 12,
    alignItems: 'flex-start',
    width: Utility.getScreenWidth() - 72,
  },
  cartAddressTextContainer: {
    flexDirection: 'row',
  },
  contactNameText: {
    fontFamily: 'Roboto-Regular',
    fontSize: size.h4,
    color: colors.foxyBlack,
    flex: 1,
  },
  addressTextMedium: {
    fontFamily: 'Roboto-Medium',
    fontSize: 12,
    color: colors.foxyBlack,
  },
  addressTextName: {
    fontFamily: 'Roboto-Regular',
    fontSize: size.h4,
    color: colors.foxyBlack,
    flexWrap: 'wrap',
    flex: 1,
  },
  radioButtonContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    height: 40,
    width: 40,
    alignSelf: 'center',
  },
  promoButtonContainer: {
    height: 48,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    marginTop: 12,
    backgroundColor: colors.white,
    paddingLeft: 12,
  },
  promoCodeImage: {
    height: 24,
    width: 24,
    marginLeft: Utility.padding,
  },
  promoCodeText: {
    fontFamily: 'Roboto-Medium',
    fontSize: 14,
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#173143',
  },
  selectedPaymentLogo: {
    marginLeft: Utility.largePadding,
    width: 40,
    height: 24,
    resizeMode: 'contain',
    borderRadius: 2,
  },
  animatedScreenInModalStyle: {
    position: 'absolute',
    backgroundColor: 'white',
    height: '100%',
    borderTopLeftRadius: 6,
    borderTopRightRadius: 6,
  },
  pricingDetailsContainer: {
    alignItems: 'flex-start',
    width: Utility.getScreenWidth(),
    marginTop: 12,
    backgroundColor: colors.white,
    paddingTop: 4,
    paddingBottom: 4,
  },
  itemTotaltext: {
    fontFamily: 'Roboto-Regular',
    fontSize: 12,

    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#173143',
    marginLeft: 12,
    marginTop: 4,
    marginBottom: 4,
  },
  grandTotaltext: {
    fontFamily: 'Roboto-Regular',
    fontSize: 12,
    fontStyle: 'normal',
    letterSpacing: 0,
    color: colors.foxyBlack,
    marginLeft: 12,
    marginTop: 4,
    marginBottom: 8,
  },
  price: {
    position: 'absolute',
    fontFamily: 'Roboto-Regular',
    fontSize: 12,

    fontStyle: 'normal',

    color: '#173143',
    right: 12,
    alignSelf: 'center',
  },
  priceHeader: {
    fontFamily: 'Roboto-Medium',
    fontSize: 14,

    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#173143',
    paddingLeft: 12,
    paddingBottom: 8,
    paddingTop: 4,
  },
  pricingTextContainer: {
    flexDirection: 'row',
    width: '100%',
    marginTop: 4,
  },
  grandTotalPrice: {
    position: 'absolute',
    fontFamily: 'Roboto-Medium',
    fontSize: 14,

    fontStyle: 'normal',
    letterSpacing: 0,
    color: colors.foxyBlack,
    right: 12,
    alignSelf: 'center',
  },
  verticalSpacing: {
    height: 100,
  },
  verticalSpacingCart: {
    height: 120,
  },
  selectedPaymentText: {
    fontFamily: 'Roboto-Regular',
    fontSize: 14,

    fontStyle: 'normal',
    marginLeft: 6,
    maxWidth: '45%',
    color: colors.silver,
  },
  changePaymentButtonText: {
    color: '#449386',
    fontFamily: 'Roboto-Regular',
    fontSize: 14,

    fontStyle: 'normal',
  },
  emptyStateContainer: { flex: 1, backgroundColor: colors.background },
  emptyBagImageContainer: {
    height: 220,
    justifyContent: 'center',
    alignItems: 'center',
  },
  headerText: {
    fontFamily: 'Roboto-Regular',
    fontSize: 16,

    fontStyle: 'normal',
    color: colors.foxyBlack,
    margin: 4,
  },
  subtitleText: {
    fontFamily: 'Roboto-Regular',
    fontSize: 12,

    fontStyle: 'normal',
    color: colors.subtitle,
    margin: 4,
    maxWidth: 150,
    textAlign: 'center',
  },
  emptyBagImage: {
    marginTop: 48,
    height: 54,
    width: 58,
  },
  headingContainer: {
    flexDirection: 'row',
    marginLeft: 12,
    marginRight: 12,
    marginBottom: 8,
    marginTop: 12,
  },
  subHeading: {
    fontSize: 16,
    lineHeight: 16,
    fontFamily: 'Roboto-Medium',
    fontStyle: 'normal',
    letterSpacing: 0,
    color: '#173143',
    flex: 1,
    alignContent: 'flex-start',
  },
  priceShimmer: {
    height: 16,
    width: 54,
    marginTop: 4,
  },
  actionBottonContainer: {
    position: 'absolute',
    height: 70,
    bottom: 0,
    width: Utility.getScreenWidth(),
    flexDirection: 'column',
    justifyContent: 'flex-start',
    zIndex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 4,
  },
  giftImageInStrip: {
    height: 48,
    width: 48,
    marginLeft: 24,
    marginTop: 8,
    marginBottom: 8,
  },
  giftStripContainer: {
    height: 64,
    width: '100%',
    backgroundColor: colors.white,
    flexDirection: 'row',
    alignItems: 'center',
  },
  foxySurpriseHeader: {
    fontFamily: 'Roboto-Regular',
    color: colors.foxyBlack,
    fontSize: size.h4,

    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'left',
    alignItems: 'flex-start',
    marginTop: 4,
    lineHeight: 14,
    marginLeft: 24,
  },

  moreButton: {
    height: 16,
    width: 16,
    resizeMode: 'contain',
    // tintColor: colors.foxyBlack,
    marginRight: 14,
    backgroundColor: 'red',
  },
  menuOptionStyle: {
    fontFamily: 'Roboto-Regular',
    color: colors.foxyBlack,
    fontSize: size.h3,

    fontStyle: 'normal',
    letterSpacing: 0,
    margin: 6,
  },
  contactLessDeliveryContainer: {
    flex: 1,
    flexDirection: 'row',
    marginTop: 5,
    marginBottom: 1,
    backgroundColor: 'white',
    paddingHorizontal: 20,
    paddingVertical: 5,
  },
  checkBoxContainer: {
    height: 14,
    borderColor: colors.silver,
    borderWidth: 0.4,
    borderRadius: 3,
    width: 14,
    marginTop: 8,
  },
  checkBox: {
    height: 14,
    width: 14,
    borderRadius: 2,
  },
  checkBoxTextContainer: { width: '90%', flexDirection: 'column' },

  checkBoxHeading: {
    fontFamily: 'Roboto-Bold',
    fontSize: 14,
    fontStyle: 'normal',
    letterSpacing: 0,
    color: colors.foxyBlack,
    marginLeft: 16,
    marginTop: 4,
  },
  checkBoxSubHeading: {
    fontFamily: 'Roboto-Regular',
    fontSize: 14,

    fontStyle: 'normal',
    letterSpacing: 0,
    color: colors.silver,
    marginLeft: 16,
    marginBottom: 4,
  },
  removeOfferButton: { position: 'absolute', right: 24, alignSelf: 'center' },
  removeOfferText: {
    fontFamily: 'Roboto-Medium',
    color: colors.foxyPink,
    fontSize: size.h4,
    letterSpacing: 0,
  },
  cartLoadingOverlay: {
    flex: 1,
    position: 'absolute',
    height: Utility.getScreenHeight(),
    width: Utility.getScreenWidth(),
    backgroundColor: '#000000',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    opacity: 0.5,
    zIndex: 1,
  },
  toast: {
    position: 'absolute',
    bottom: 60,
    maxWidth: Utility.getScreenWidth() - 32,
  },
  delayedDeliveryText: {
    fontSize: 12,
    fontFamily: 'Roboto-Regular',
    color: '#979BAA',
    paddingBottom: 8,
  },
  promiseDeliverySubText: {
    fontFamily: 'Roboto-Regular',
    fontSize: 12,
    fontStyle: 'normal',
    color: colors.silver,
  },
  promiseDeliveryTitle: {
    fontFamily: 'Roboto-Regular',
    fontSize: 12,
    fontStyle: 'normal',
    color: colors.foxyBlack,
  },
  promiseDeliveryContainer: { marginTop: 8 },
  addressDeliveryHeading: {
    fontFamily: 'Roboto-Regular',
    fontSize: 12,
    color: colors.foxyBlack,
  },
  truckImage: { height: 24, width: 24, resizeMode: 'contain' },
  addressDeliveryContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  promiseDeliveryBox: {
    backgroundColor: '#FFEEF2',
    padding: 12,
    borderRadius: 8,
    marginBottom: 8,
  },
  verticalPadding: {
    paddingBottom: 8,
  },
  emptyAddressContainer: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 16,
  },
  emptyAddressText: {
    fontFamily: 'Roboto-Regular',
    fontSize: 14,
    color: colors.foxyBlack,
  },
  chooseFreeGiftConfirmButtonText: {
    fontFamily: 'Roboto',
    fontSize: 16,
    fontWeight: '500',
    fontStyle: 'normal',
    letterSpacing: 0,
    textAlign: 'center',
    color: colors.white,
  },
  chooseFreeGiftButtonContainer: {
    marginTop: 8,
    height: 44,
    backgroundColor: colors.green,
    borderRadius: 4,
    justifyContent: 'center',
    alignItems: 'center',
    width: '85%',
    alignSelf: 'center',
    flexDirection: 'row',
    marginBottom: Utility.bottomInset,
  },
  offerPromptShimmerContainer: {
    backgroundColor: colors.white,
    padding: 16,
  },
  offerPromptShimmer: {
    width: 200,
    marginHorizontal: 12,
    borderRadius: 4,
    opacity: 0.5,
  },
  loadingContainer: {
    height: Utility.getWindowHeight(),
    width: Utility.getScreenWidth(),
    alignItems: 'center',
    justifyContent: 'center',
  },
  spShimmer: { width: 54, marginRight: 4, borderRadius: 2 },
  mrpShimmer: { width: 54, borderRadius: 2 },
  discountShimmer: { width: 54, borderRadius: 2, marginLeft: 8 },

  shimmerContainer: { flexDirection: 'row' },
  loaderContainer: {
    height: Utility.getScreenHeight() / 2,
    justifyContent: 'center',
    alignItems: 'center',
  },
  divider: { height: 120, backgroundColor: colors.background },
  actionButton: {
    position: 'absolute',
    width: Utility.getScreenWidth(),
    flexDirection: 'column',
    zIndex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 4,
    height: 70 + Utility.bottomInset,
    bottom: 0,
    backgroundColor: colors.background,
  },
  indicatorContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    height: Utility.getScreenHeight() / 2,
  },

  holdButtonContainerContainer: {
    width: 182,
    height: 40,
    borderRadius: 4,
    borderWidth: 1,
    borderColor: colors.black,
    justifyContent: 'center',
    alignItems: 'center',

    alignSelf: 'center',
    right: 7,
    position: 'absolute',
  },

  holdBillingButton: {
    fontFamily: 'Roboto-Medium',
    color: colors.foxyBlack,
    fontSize: size.h1,
  },
});

export default CartStyles;
